import { render, staticRenderFns } from "./FundResults.vue?vue&type=template&id=f8631964&scoped=true"
import script from "./FundResults.vue?vue&type=script&lang=js"
export * from "./FundResults.vue?vue&type=script&lang=js"
import style0 from "./FundResults.vue?vue&type=style&index=0&id=f8631964&prod&scoped=true&lang=css"
import style1 from "./FundResults.vue?vue&type=style&index=1&id=f8631964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8631964",
  null
  
)

export default component.exports